
import { showModalDialog } from "@/helpers/dialog";
import { isNative } from "@/ipc/renderer";
import { Action, Mutation, useStore } from "@/store";
import { defineComponent, onMounted, ref, Ref } from "vue";

export default defineComponent({
  name: "PasteDialog",
  setup() {
    const store = useStore();
    const dialog: Ref = ref(null);
    const textarea: Ref = ref(null);

    store.commit(Mutation.RETAIN_BUSSY_STATE);
    onMounted(async () => {
      try {
        showModalDialog(dialog.value);
        if (isNative()) {
          textarea.value.value = await navigator.clipboard.readText();
        }
      } finally {
        store.commit(Mutation.RELEASE_BUSSY_STATE);
      }
    });

    const onOk = () => {
      const data = textarea.value.value;
      store.commit(Mutation.CLOSE_PASTE_DIALOG);
      if (data) {
        store.dispatch(Action.PASTE_RECORD, data);
      }
    };

    const onCancel = () => {
      store.commit(Mutation.CLOSE_PASTE_DIALOG);
    };

    return {
      dialog,
      textarea,
      onOk,
      onCancel,
      isNative: isNative(),
    };
  },
});
